import { useQuery } from '@tanstack/react-query'

import { TServiceTemplate } from '~/features/templates/models'
import queryKeys from '~/features/templates/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const useGetServiceTemplates = (filters: object = {}) => {
  return useQuery({
    queryKey: queryKeys.templates(filters),
    queryFn: () =>
      HttpService.get<TServiceTemplate[]>(
        {
          path: EServerPath.templates,
          query: filters as Record<string, string>,
        },
        EHttpService.agent,
      ),
  })
}

export default useGetServiceTemplates
